import { Reveal, Overline } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { OFFERS, SITES } from "../data/content";

export const Listings = ({ t, lang }) => (
  <section id="listings" data-testid="listings-section" className="py-24 md:py-36 bg-copou-bg">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="max-w-2xl mb-14">
        <Overline>{t.listings.overline}</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-4 text-copou-ink">{t.listings.title}</h2>
        <p className="mt-5 text-copou-muted leading-relaxed">{t.listings.subtitle}</p>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-8">
        {OFFERS.map((o, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <a
              href={o.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`offer-card-${i}`}
              className="group block bg-copou-surface border border-copou-line hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img src={o.img} alt={o.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-4 left-4 bg-copou-bg/95 text-copou-primary text-[11px] font-semibold uppercase tracking-wider px-3 py-1.5">
                  {o.tag[lang]}
                </span>
              </div>
              <div className="p-7">
                <div className="text-xs uppercase tracking-wider text-copou-muted">{o.zone}</div>
                <h3 className="font-serif text-xl text-copou-ink mt-2 leading-snug min-h-[3.5rem]">{o.title}</h3>
                <div className="font-serif text-3xl text-copou-primary mt-3">{o.price}</div>
                <div className="flex flex-wrap gap-x-4 gap-y-1 mt-4 text-sm text-copou-muted border-t border-copou-line pt-4">
                  {o.meta.map((m, j) => <span key={j}>{m}</span>)}
                </div>
                <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-copou-primary group-hover:gap-3 transition-all">
                  {t.listings.detail}
                  <ArrowUpRight size={16} />
                </div>
              </div>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-12 text-center">
        <a
          href={SITES.unuOffers}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="listings-all-cta"
          className="inline-flex items-center gap-2 border border-copou-primary text-copou-primary px-8 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-copou-primary hover:text-white transition-colors"
        >
          {t.listings.cta}
          <ArrowUpRight size={16} />
        </a>
      </Reveal>
    </div>
  </section>
);
